// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;utf8,      <svg xmlns=\"http://www.w3.org/2000/svg\">        <filter id=\"recolor\" color-interpolation-filters=\"sRGB\">          <feColorMatrix type=\"matrix\" values=\"            0 0 0 0 0.2941176471            0 0 0 0 0.1568627451            0 0 0 0 0.4274509804            0 0 0 1 0          \"/>        </filter>      </svg>      #recolor", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml;utf8,      <svg xmlns=\"http://www.w3.org/2000/svg\">        <filter id=\"recolor\" color-interpolation-filters=\"sRGB\">          <feColorMatrix type=\"matrix\" values=\"            0 0 0 0 0.8039215686            0 0 0 0 0.7058823529            0 0 0 0 0.9019607843            0 0 0 1 0          \"/>        </filter>      </svg>      #recolor", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml;utf8,      <svg xmlns=\"http://www.w3.org/2000/svg\">        <filter id=\"recolor\" color-interpolation-filters=\"sRGB\">          <feColorMatrix type=\"matrix\" values=\"            0 0 0 0 1            0 0 0 0 1            0 0 0 0 1            0 0 0 1 0          \"/>        </filter>      </svg>      #recolor", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml;utf8,      <svg xmlns=\"http://www.w3.org/2000/svg\">        <filter id=\"recolor\" color-interpolation-filters=\"sRGB\">          <feColorMatrix type=\"matrix\" values=\"            0 0 0 0 0.0784313725            0 0 0 0 0.0784313725            0 0 0 0 0.0784313725            0 0 0 1 0          \"/>        </filter>      </svg>      #recolor", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** function to get dimensions
  usage example to get \`tablet\` value from \`\$page-max-widths\`
  .class {
    max-width: dim(\$page-max-widths, tablet);
  }

 */
.cards-module__btn-container____fCFU {
  display: inline-block;
  width: -moz-fit-content;
  width: fit-content;
}

.cards-module__ghost-btn___V7g6m {
  display: flex;
  align-items: center;
  gap: 4px;
  border: none;
  padding: 0;
  background-color: transparent;
  -webkit-appearance: none;
     -moz-appearance: none;
          appearance: none;
  position: relative;
  font-size: 0.875rem;
  font-weight: 500;
  line-height: 140%;
  color: var(--primary600, #4B286D);
  cursor: pointer;
  text-decoration: underline;
}
.cards-module__ghost-btn___V7g6m img {
  width: 14px;
  filter: saturate(0%) brightness(0%) invert(29.2156862745%) opacity(1);
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
html[class*=dark-mode] .cards-module__ghost-btn___V7g6m img {
  filter: saturate(0%) brightness(0%) invert(80.3921568627%) opacity(1);
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.cards-module__contacts____SxRC {
  gap: 0 !important;
}

.cards-module__wrapper___tkkd5 {
  display: flex;
  gap: 16px;
  align-items: center;
}

.cards-module__title___GUVQv {
  font-size: 1rem;
  font-weight: 500;
  line-height: 24px;
  color: var(--neutral100, #2c2e30);
}

.cards-module__info___nPsnt {
  font-size: 0.875rem;
  color: var(--neutral75, #424547);
  line-height: 21px;
}

.cards-module__virtual-care___FkfgL {
  display: flex;
  gap: 8px;
  align-items: start;
  padding: 16px;
  text-align: start;
  background-color: rgba(var(--primary600-rgb, 75, 40, 109), 0.1);
  border-radius: 8px;
}
.cards-module__virtual-care___FkfgL img {
  width: 17px;
  filter: saturate(0%) brightness(0%) invert(29.2156862745%) opacity(1);
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}
html[class*=dark-mode] .cards-module__virtual-care___FkfgL img {
  filter: saturate(0%) brightness(0%) invert(80.3921568627%) opacity(1);
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.cards-module__btn___B_KoM img {
  width: 14px;
  margin-right: 5px;
  filter: saturate(0%) brightness(0%) invert(100%) opacity(1);
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
html[class*=dark-mode] .cards-module__btn___B_KoM img {
  filter: saturate(0%) brightness(0%) invert(7.8431372549%) opacity(1);
  filter: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.cards-module__technical-support___kfBpR {
  padding: 16px;
  text-align: start;
  background-color: var(--surface1, #fff);
  border-radius: 16px;
  width: 100%;
  border: 1px solid var(--neutral30, #e3e6e8);
  color: var(--primary600, #4b286d);
  font-weight: 500;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./node_modules/wa-storybook/styles/tools/functions/_widths.scss","webpack://./client/app/react-components/modalities/cards/cards.module.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_recolor.scss","webpack://./node_modules/wa-storybook/styles/tools/mixins/_theme.scss"],"names":[],"mappings":"AAAA;;;;;;EAAA;ACEA;EACE,qBAAA;EACA,uBAAA;EAAA,kBAAA;AAMF;;AAHA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;EACA,6BAAA;EACA,wBAAA;KAAA,qBAAA;UAAA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCAAA;EACA,eAAA;EACA,0BAAA;AAMF;AAJE;EACE,WAAA;ECbA,qEAAA;EAIA,+CAAA;ADiBJ;AElBE;EDHE,qEAAA;EAIA,+CAAA;ADqBJ;;AAHA;EACE,iBAAA;AAMF;;AAHA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAMF;;AAHA;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,iCAAA;AAMF;;AAHA;EACE,mBAAA;EACA,gCAAA;EACA,iBAAA;AAMF;;AAHA;EACE,aAAA;EACA,QAAA;EACA,kBAAA;EACA,aAAA;EACA,iBAAA;EACA,+DAAA;EACA,kBAAA;AAMF;AAJE;EACE,WAAA;ECvDA,qEAAA;EAIA,+CAAA;AD2DJ;AE5DE;EDHE,qEAAA;EAIA,+CAAA;AD+DJ;;AAFE;EACE,WAAA;EACA,iBAAA;ECnEA,2DAAA;EAIA,+CAAA;ADsEJ;AEvEE;EDHE,oEAAA;EAIA,+CAAA;AD0EJ;;AAFA;EACE,aAAA;EACA,iBAAA;EACA,uCAAA;EACA,mBAAA;EACA,WAAA;EACA,2CAAA;EACA,iCAAA;EACA,gBAAA;EACA,eAAA;AAKF","sourcesContent":["/** function to get dimensions\n  usage example to get `tablet` value from `$page-max-widths`\n  .class {\n    max-width: dim($page-max-widths, tablet);\n  }\n\n */\n\n@function dim($prop, $key) {\n  @return map-get($prop, $key);\n}\n","@import '~wa-storybook/styles/utils';\n\n.btn-container {\n  display: inline-block;\n  width: fit-content;\n}\n\n.ghost-btn {\n  display: flex;\n  align-items: center;\n  gap: 4px;\n  border: none;\n  padding: 0;\n  background-color: transparent;\n  appearance: none;\n  position: relative;\n  font-size: rem(14);\n  font-weight: 500;\n  line-height: 140%;\n  color: var(--primary600, #4B286D);\n  cursor: pointer;\n  text-decoration: underline;\n\n  img {\n    width: 14px;\n    @include recolor($color-primary600);\n\n    @include dark {\n      @include recolor($color-dark-primary600);\n    }\n  }\n}\n\n.contacts {\n  gap: 0 !important;\n}\n\n.wrapper {\n  display: flex;\n  gap: 16px;\n  align-items: center;\n}\n\n.title {\n  font-size: rem(16);\n  font-weight: 500;\n  line-height: 24px;\n  color: color(neutral100);\n}\n\n.info {\n  font-size: rem(14);\n  color: color(neutral75);\n  line-height: 21px;\n}\n\n.virtual-care {\n  display: flex;\n  gap: 8px;\n  align-items: start;\n  padding: 16px;\n  text-align: start;\n  background-color: rgba(color(primary600, true), 0.1);\n  border-radius: 8px;\n\n  img {\n    width: 17px;\n    @include recolor($color-primary600);\n\n    @include dark {\n      @include recolor($color-dark-primary600);\n    }\n  }\n}\n\n.btn {\n  img {\n    width: 14px;\n    margin-right: 5px;\n    @include recolor($color-surface1);\n\n    @include dark {\n      @include recolor($color-dark-surface1);\n    }\n  }\n}\n\n.technical-support {\n  padding: 16px;\n  text-align: start;\n  background-color: color(surface1);\n  border-radius: 16px;\n  width: 100%;\n  border: 1px solid color(neutral30);\n  color: color(primary600);\n  font-weight: 500;\n  font-size: rem(16);\n}\n","// Mixin to change colour of a png icon\n// @include recolor(#fff, 0.8)\n\n@mixin recolor($color: #000, $opacity: 1) {\n    $r: calc(red($color) / 255);\n    $g: calc(green($color) / 255);\n    $b: calc(blue($color) / 255);\n    $a: $opacity;\n      \n    // grayscale fallback if SVG from data url is not supported\n    $lightness: lightness($color);\n    filter: saturate(0%) brightness(0%) invert($lightness) opacity($opacity);\n  \n    // color filter\n    $svg-filter-id: \"recolor\";\n    filter: url('data:image/svg+xml;utf8,\\\n      <svg xmlns=\"http://www.w3.org/2000/svg\">\\\n        <filter id=\"#{$svg-filter-id}\" color-interpolation-filters=\"sRGB\">\\\n          <feColorMatrix type=\"matrix\" values=\"\\\n            0 0 0 0 #{$r}\\\n            0 0 0 0 #{$g}\\\n            0 0 0 0 #{$b}\\\n            0 0 0 #{$a} 0\\\n          \"/>\\\n        </filter>\\\n      </svg>\\\n      ##{$svg-filter-id}');\n  }","//  Mixins to easily add style for light / dark modes only\n//\n//  Example: Let's say you need to add a shadow only for the light mode\n//      @include light {\n//          box-shadow: 8px 8px 40px #000000;\n//      }\n\n@mixin light {\n  html[class*='light-mode'] & {\n    @content;\n  }\n}\n\n@mixin dark {\n  html[class*='dark-mode'] & {\n    @content;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"btn-container": `cards-module__btn-container____fCFU`,
	"ghost-btn": `cards-module__ghost-btn___V7g6m`,
	"contacts": `cards-module__contacts____SxRC`,
	"wrapper": `cards-module__wrapper___tkkd5`,
	"title": `cards-module__title___GUVQv`,
	"info": `cards-module__info___nPsnt`,
	"virtual-care": `cards-module__virtual-care___FkfgL`,
	"btn": `cards-module__btn___B_KoM`,
	"technical-support": `cards-module__technical-support___kfBpR`
};
export default ___CSS_LOADER_EXPORT___;
